import { useContext } from 'react';
import { UserProductNotificationContext } from '../customContext/userProductNotificationProvider';

export function useUserProductNotificationCtx(){
    const ctx = useContext(UserProductNotificationContext);
    if(!ctx){
        throw new Error("useUserProductNotificationCtx must be used within the UserProductNotificationProvider context")
    }
    return ctx
}